
import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class DifficultyIndicator extends Vue {
  @Prop({default: 0, required: true}) difficultyLevel!: number | null;
  @Prop({default: false, required: false}) isTransparent!: boolean;
  @Prop({default: false, required: false}) isLarge! : boolean;
  @Prop({default: false, required: false}) fromSkill!: boolean;

  colors: string[] = ['#b8e994', '#20bf6b', '#ffbe76', '#fd7272','#d6a2e8']

  get realDifficultyLevel() {
    if(this.fromSkill) {
      if(this.difficultyLevel === 3) {
        return 2
      }
      else if(this.difficultyLevel === 4) {
        return 2
      }
      else if(this.difficultyLevel === 5) {
        return 3
      }
      else if(this.difficultyLevel === 6) {
        return 4
      }
      else if(this.difficultyLevel === 7) {
        return 5
      }
      return this.difficultyLevel
    }
    return this.difficultyLevel
  }

  get textDifficulty() {
    switch (this.realDifficultyLevel) {
      case null:
        return this.$t('difficultyIndicator.generic')
      case 0:
        return this.$t('difficultyIndicator.intermediate');
      case 1:
        return this.$t('difficultyIndicator.novice');
      case 2:
        return this.$t('difficultyIndicator.beginner');
      case 3:
        return this.$t('difficultyIndicator.intermediate');
      case 4:
        return this.$t('difficultyIndicator.advanced');
      case 5:
        return this.$t('difficultyIndicator.pro');
    }
    return 'difficulty-0';
  }
}
